import { ModalidadI } from "interfaces/Modalidad";
import { NivelI } from "interfaces/Nivel";
import { OpcionPedagogicaI } from "interfaces/OpcionPedagogica";
import { CombinatoriaI } from "interfaces/Combinatoria";

export interface infoFetchGetCombinatoriaI {
  id: number | string;
  modalidad: ModalidadI;
  nivel: NivelI;
  opcion_pedagogica: OpcionPedagogicaI;
}

class Combinatoria implements CombinatoriaI {
  id: number | string;
  modalidad: ModalidadI;
  nivel: NivelI;
  opcion_pedagogica: OpcionPedagogicaI;

  constructor(dto: infoFetchGetCombinatoriaI) {
    this.id = dto.id;
    this.modalidad = dto.modalidad;
    this.nivel = dto.nivel;
    this.opcion_pedagogica = dto.opcion_pedagogica;
  }
}

export const makeCombinatoria = (infoFetch: infoFetchGetCombinatoriaI) => {
  return new Combinatoria(infoFetch);
};
